class FaqsAccordion {
    constructor() {
        this.accordionContainer = document.querySelector(".faqs-accordions");
        if (!this.accordionContainer) return;

        this.accordionItems = Array.from(this.accordionContainer.querySelectorAll(".faqs-details"));

        this.accordionItems.forEach((item) => {
            const title = item.querySelector(".faq-title");
            const content = item.querySelector(".faq-content");

            if (content) {
                content.style.overflow = "hidden";
                content.style.transition = "height 0.3s ease-out";
                content.dataset.height = content.scrollHeight; // Store actual height
                
                // Check if item should be open by default
                if (item.classList.contains("open")) {
                    content.style.height = content.dataset.height + "px";
                } else {
                    content.style.height = "0px";
                }
            }

            title.addEventListener("click", (event) => {
                event.preventDefault();
                this.toggleAccordion(item);
            });
        });
    }

    toggleAccordion(selectedItem) {
        this.accordionItems.forEach((item) => {
            const isOpen = item.classList.contains("open");
            this.toggleFaq(item, item === selectedItem ? !isOpen : false);
        });
    }

    toggleFaq(item, shouldOpen) {
        const content = item.querySelector(".faq-content");
        if (!content) return;

        if (shouldOpen) {
            content.style.height = content.dataset.height + "px";
            content.addEventListener("transitionend", function onEnd() {
                content.style.height = "auto"; // Prevent height issues after transition
                content.removeEventListener("transitionend", onEnd);
            });
        } else {
            content.style.height = content.dataset.height + "px"; // Set height before collapsing
            requestAnimationFrame(() => (content.style.height = "0px"));
        }

        item.classList.toggle("open", shouldOpen);
    }
}

document.addEventListener("DOMContentLoaded", () => new FaqsAccordion());
